import {
	REQUESTING,
	ROUTES,
	CREATE_QUIZ,
	RECIPE,
	PLAY_QUIZ,
	DETAILED_RECIPE
} from '../constants';
import Errors from '../errors';
import { requestError } from './error';
import { registQuizListener, getQuizzes } from './question';
import firebaseAdaptor from '../firebaseAdaptor';
import i18n from '../i18n';

var db = firebaseAdaptor.db;


const recipesDispatcher = (dispatch) => (fetchingState, newRecipes) => {
	dispatch({
		type: CREATE_QUIZ.READ_RECIPES,
		payload: {
			fetchingState,
			newRecipes
		}
	});
};

const readRecipe = (type, fetchingState, recipe) => ({
	type: type,
	payload: {
		fetchingState: fetchingState,
		recipe: recipe
	}
});

export const requestRecipeId = (recipeId) => ({
	type: ROUTES.SHOW_RECIPE,
	payload: {
		recipeId: recipeId
	}
});

export function updateRecipe(value, recipeId) {
	return (dispatch) => {
		db.collection('recipes').doc(recipeId).set({
			...value,
			lastUpdate : Date.now()
		}, { merge: true })
			.catch(function (error) {
				dispatch(requestError(RECIPE.UPDATE_RECIPE, error,Errors.UpdateRecipeFailed));
			});
	};
}

const runRecipeTransaction = (recipe, then, getNewData)=>{
	return (dispatch, getState) => {
		let transactionEnded = false;
		const { id } = recipe;
		const docRef = db.collection('recipes').doc(id);
		const unsubscribe = docRef.onSnapshot(function (doc) {
			if (transactionEnded) {
				const newRecipe = {
					id,
					...recipe,
					...doc.data()
				};
				dispatch(readRecipe(DETAILED_RECIPE.READ_RECIPE, REQUESTING.LOADED, newRecipe));
				unsubscribe();
			}
		});
		db.runTransaction(function (transaction) {
			return transaction.get(docRef).then(function (doc) {
				if (!doc.exists) {
					dispatch(requestError(DETAILED_RECIPE.READ_RECIPE, 'Document does not exist!', Errors.UpdateRecipesFailed));
				}
				const data = doc.data();
				const newData = getNewData && getNewData(data,getState);
				transaction.update(docRef, newData);
			});
		})
			.then(function () {
				transactionEnded = true;
				then && then();
			})
			.catch(function (error) {
				transactionEnded = true;
				dispatch(requestError(DETAILED_RECIPE.READ_RECIPE, error, Errors.UpdateRecipesFailed));
			});
	};
};

const appendToArrayInTransaction = (key) => (recipe, uid, then) => {
	return runRecipeTransaction(recipe,then,(oldData)=>{
		if (oldData[key] === undefined) {
			return {[key]:[uid]};
		}
		return {[key]:[uid,...oldData[key]]};
	});
};

const removeFromArrayInTransaction = (key) => (recipe, uid, then) => {
	return runRecipeTransaction(recipe,then,(oldData)=>{
		if (oldData[key] === undefined) {
			return {[key]:[]};
		}
		const newData = oldData[key].filter(id=>id!==uid);
		return {[key]:newData};
	});
};

export function likesByUser(recipe, uid, then) {
	return appendToArrayInTransaction('likeFrom')(recipe, uid, then);
}
export function removeLikesByUser(recipe, uid, then) {
	return removeFromArrayInTransaction('likeFrom')(recipe, uid, then);
}
export function thumbByUser(recipe, uid, then) {
	return appendToArrayInTransaction('thumbFrom')(recipe, uid, then);
}
export function removeThumbByUser(recipe, uid, then) {
	return removeFromArrayInTransaction('thumbFrom')(recipe, uid, then);
}

export function addRecipe(recipeName) {
	return (dispatch, getState) => {
		const { auth, profileReducer } = getState();
		const { imageUrl } = profileReducer;
		if (auth) {
			db.collection('recipes').add({
				uid: auth.uid,
				userName: profileReducer.userName,
				name: recipeName,
				imageUrl,
			})
				.catch(function (error) {
					dispatch(requestError(CREATE_QUIZ.ERRORS.CREATE_RECIPE, error, Errors.AddRecipeFailed));
				});
		}

	};
}

export async function registListener(dispatch, getState) {
	const { auth } = getState();
	const unsubscribe = db.collection('recipes').where('uid', '==', auth.uid)
		.onSnapshot(function (querySnapshot) {
			const { createQuiz } = getState();
			var recipes = [...createQuiz.recipes];
			for (let change of querySnapshot.docChanges) {
				let recipe = Object.assign({ id: change.doc.id }, change.doc.data());
				if (change.type === 'added') {
					recipe.unsubscribe = registQuizListener(dispatch, recipe.id, getState);
					recipes.push(recipe);
				}
				else if (change.type === 'modified') {
					recipes = recipes.map(r => r.id === recipe.id ? { quizzes: r.quizzes, ...recipe } : r);
				}
				else if (change.type === 'removed') {
					recipes = recipes.filter(r => r.id !== recipe.id);
				}
			}
			dispatch({
				type : CREATE_QUIZ.READ_RECIPES,
				payload : {
					newRecipes : recipes,
					fetchingState : REQUESTING.LOADED,
				}
			});
		});
	dispatch({
		type : CREATE_QUIZ.READ_RECIPES,
		payload : {
			fetchingState : REQUESTING.LISTENING,
			unsubscribe
		}
	});
}

export function unregistListener(dispatch, getState) {
	const { createQuiz } = getState();
	const {recipes,unsubscribe} = createQuiz;
	for(const recipe of recipes){
		recipe.unsubscribe && recipe.unsubscribe();
	}
	unsubscribe && unsubscribe();
	dispatch({
		type : CREATE_QUIZ.READ_RECIPES,
		payload : {
			fetchingState : REQUESTING.LISTENING,
			unsubscribe : null
		}
	});
}

export function initRecipes(dispatch){
	dispatch({
		type : CREATE_QUIZ.INIT_RECIPES,
		payload : {
			fetchingState : REQUESTING.LOADED,
		}
	});
}

function loadRecipeBase(recipeId, successCb, failCb, preCheckCb) {
	db.collection('recipes').doc(recipeId).get()
		.then(async function (data) {
			if (!data.exists) {
				failCb('documents not exists');
				return;
			}
			let retRecipe = Object.assign({ id: recipeId }, data.data());
			try {
				preCheckCb && preCheckCb(retRecipe);
				const quizzes = await getQuizzes(recipeId);
				retRecipe.quizzes = quizzes;
				successCb(retRecipe);
			} catch (error) {
				failCb(error);
			}
		})
		.catch(error => {
			failCb(error);
		});
}

export async function loadRecipeForSearch(dispatch, getState) {
	const { location,auth } = getState();
	const { recipeId } = location.payload;
	loadRecipeBase(recipeId, (recipe) => {
		dispatch(readRecipe(DETAILED_RECIPE.READ_RECIPE, REQUESTING.LOADED, recipe));
	}, (error) => {
		dispatch(requestError(DETAILED_RECIPE.READ_RECIPE,error, Errors.NoRecipeFound));
	}, (recipe) => {
		if(recipe.uid!==auth.uid && !recipe.published){
			throw Error(i18n.t('error.AccessPrivateRecipe'));
		}
	});
	dispatch(readRecipe(DETAILED_RECIPE.READ_RECIPE, REQUESTING.FETCHING, null));
}

export async function loadRecipeForPlay(dispatch, getState) {
	const { location, auth } = getState();
	const { recipeId } = location.payload;
	loadRecipeBase(recipeId, (recipe) => {
		dispatch(readRecipe(PLAY_QUIZ.READ_RECIPE, REQUESTING.LOADED, recipe));
	}, (error) => {
		dispatch(requestError(PLAY_QUIZ.READ_RECIPE,error, Errors.NotFoundRecipe));
	}, (recipe) => {
		if(!recipe.published){
			if(recipe.uid !== auth.uid){
				throw Error(i18n.t('error.AccessPrivateRecipe'));
			}
		}
	});
	dispatch(readRecipe(PLAY_QUIZ.READ_RECIPE, REQUESTING.FETCHING, null));
}

export async function loadRecipes(dispatch, getState) {
	const { auth } = getState();
	const dispatchReadRecipes = recipesDispatcher(dispatch, getState);
	try {
		db.collection('recipes')
			.where('uid', '==', auth.uid).get().then(async function (querySnapshot) {
				let promises = [];
				querySnapshot.forEach(function (doc) {
					const f = async function () {
						const quizzes = await getQuizzes(doc.id);
						let recipe = Object.assign({ id: doc.id }, doc.data());
						recipe.quizzes = quizzes;
						return recipe;
					};
					promises.push(f());
				});
				const recipes = await Promise.all(promises);
				dispatchReadRecipes(REQUESTING.LOADED, recipes);
			});
		dispatchReadRecipes(REQUESTING.FETCHING, []);
	} catch (error) {
		dispatch(requestError(CREATE_QUIZ.READ_RECIPES, error, Errors.NoRecipeFound));
	}

}

export function deleteRecipe(recipe) {
	return (dispatch) => {
		if (recipe.unsubscribe) {
			recipe.unsubscribe();
		}
		db.collection('recipes')
			.doc(recipe.id)
			.delete()
			.catch(function (error) {
				dispatch(requestError(RECIPE.DELETE_RECIPE, error, Errors.DeleteRecipeFailed));
			});
		dispatch({
			type: ROUTES.CREATE_QUIZ_SELECTED
		});
	};
}
